/**
 * Converts a YouTube watch URL into an embed URL.
 * e.g. https://youtube.com/watch?v=abc123 → https://www.youtube.com/embed/abc123
 * @param {string} url
 * @returns {string|null}
 */
export function getYouTubeEmbedUrl(url) {
  if (!url) return null;
  const match = url.match(/(?:v=|youtu\.be\/)([^&?/]+)/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}

/**
 * Converts a Spotify episode URL into an embed URL.
 * e.g. https://open.spotify.com/episode/abc → https://open.spotify.com/embed/episode/abc
 * @param {string} url
 * @returns {string|null}
 */
export function getSpotifyEmbedUrl(url) {
  if (!url) return null;
  const match = url.match(/episode\/([^?]+)/);
  return match ? `https://open.spotify.com/embed/episode/${match[1]}` : null;
}
